import { COLOR_RANGE_LIST } from "@/modules/productivity-cockpit/types/ColorRanges"

const GAUGE_CHART_LIST = {
  OBC: {
    min: 0,
    max: 14,
    step: 2,
    separatorRanges: [6, 8],
    colorRanges: [COLOR_RANGE_LIST.GREEN, COLOR_RANGE_LIST.YELLOW, COLOR_RANGE_LIST.RED],
  },
  OBC_WZ: {
    min: 0,
    max: 4,
    step: 0.5,
    separatorRanges: [1, 2, 3],
    colorRanges: [COLOR_RANGE_LIST.CRITICAL, COLOR_RANGE_LIST.RED, COLOR_RANGE_LIST.YELLOW, COLOR_RANGE_LIST.GREEN],
  },
  STEERING_LEVEL: {
    min: -1,
    max: 4,
    step: 1,
    separatorRanges: [1, 2, 3],
    colorRanges: [COLOR_RANGE_LIST.GREEN, COLOR_RANGE_LIST.YELLOW, COLOR_RANGE_LIST.RED, COLOR_RANGE_LIST.CRITICAL],
  },
  PRODUCTIVITY: {
    min: 0,
    max: 7,
    step: 1,
    separatorRanges: [3, 4],
    colorRanges: [COLOR_RANGE_LIST.RED, COLOR_RANGE_LIST.YELLOW, COLOR_RANGE_LIST.GREEN],
  },
}

type GaugeChartType = keyof typeof GAUGE_CHART_LIST

export { GAUGE_CHART_LIST, type GaugeChartType }
